module.exports = __webpack_public_path__ + "static/media/undraw_website_setup_5hr2.c1fd998f.svg";